var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudienceEmpty1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 201,
    viewBox: "0 0 200 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_24415)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100.2,
    r: 87.5,
    fill: "#E9E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7074 79.6742L129.348 52.4373C133.617 51.0304 135.751 50.327 137.537 50.6504C138.36 50.7995 139.133 51.0968 139.825 51.5253L149.177 56.5281L144.432 64.408L153.618 115.253L153.618 115.253C154.418 119.676 154.817 121.887 154.292 123.85C153.829 125.577 152.882 127.17 151.584 128.4C150.109 129.798 147.975 130.501 143.706 131.908L61.0656 159.145L60.3617 165.331L51.0312 160.307C50.9612 160.271 50.8919 160.234 50.8233 160.196C50.0997 159.789 49.4558 159.244 48.9219 158.578C47.7859 157.163 47.3863 154.951 46.5872 150.528L36.795 96.3297C35.9959 91.9067 35.5963 89.6951 36.1218 87.732C36.5841 86.0051 37.5319 84.4126 38.8293 83.1827C40.3042 81.7846 42.4386 81.0811 46.7074 79.6742Z",
    fill: "#CABCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.21 56.5454L149.177 56.5281M149.177 56.5281L139.825 51.5253C139.133 51.0968 138.36 50.7995 137.537 50.6504C135.751 50.327 133.617 51.0304 129.348 52.4373L46.7074 79.6742C42.4386 81.0811 40.3042 81.7846 38.8293 83.1827C37.5319 84.4126 36.5841 86.0051 36.1218 87.732C35.5963 89.6951 35.9959 91.9067 36.795 96.3297L46.5872 150.528C47.3863 154.951 47.7859 157.163 48.9219 158.578C49.4558 159.244 50.0997 159.789 50.8233 160.196M149.177 56.5281L144.432 64.408L153.618 115.253C154.418 119.676 154.817 121.887 154.292 123.85C153.829 125.577 152.882 127.17 151.584 128.4C150.109 129.798 147.975 130.501 143.706 131.908L61.0656 159.145L60.3617 165.331L51.0312 160.307M50.8233 160.196L51.0312 160.307M50.8233 160.196C50.8919 160.234 50.9612 160.271 51.0312 160.307",
    stroke: "black",
    strokeWidth: 1.33098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2774 101.435C45.4783 97.0121 45.0787 94.8006 45.6043 92.8374C46.0665 91.1106 47.0143 89.5181 48.3117 88.2882C49.7866 86.8901 51.921 86.1866 56.1898 84.7797L138.83 57.5428C143.099 56.1359 145.233 55.4324 147.019 55.7558C148.59 56.0403 149.975 56.8642 150.974 58.1094C152.11 59.525 152.509 61.7365 153.309 66.1596L163.101 120.358C163.9 124.781 164.3 126.993 163.774 128.956C163.312 130.683 162.364 132.275 161.067 133.505C159.592 134.903 157.457 135.607 153.188 137.014L70.5481 164.25C66.2793 165.657 64.1449 166.361 62.3589 166.037C60.7879 165.753 59.4036 164.929 58.4043 163.684C57.2683 162.268 56.8688 160.057 56.0696 155.634L46.2774 101.435Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33098
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.604 92.8377C45.0785 94.8009 45.478 97.0124 46.2772 101.435L46.9012 104.889L153.932 69.6136L153.308 66.1598C152.509 61.7367 152.11 59.5252 150.974 58.1096C149.974 56.8644 148.59 56.0406 147.019 55.7561C145.233 55.4327 143.099 56.1361 138.83 57.5431L56.1896 84.7799C51.9208 86.1868 49.7864 86.8903 48.3114 88.2885C47.014 89.5183 46.0663 91.1108 45.604 92.8377Z",
    fill: "#6E45EA",
    stroke: "black",
    strokeWidth: 1.33098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.355 94.7506C142.908 86.7388 135.466 82.31 127.734 84.8584C127.164 85.0461 126.609 85.2665 126.07 85.5168L130.355 99.3649L144.355 94.7506Z",
    fill: "#410FD3",
    stroke: "black",
    strokeWidth: 1.33098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.354 94.7509L130.354 99.3652L143.596 103.201C144.557 100.511 144.868 97.5962 144.354 94.7509Z",
    fill: "#7E33E9",
    stroke: "black",
    strokeWidth: 1.33098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.115 112.075C124.275 114.514 128.578 115.321 132.975 113.872C137.961 112.228 141.85 108.085 143.596 103.2L130.354 99.365L121.115 112.075Z",
    fill: "#F56087",
    stroke: "black",
    strokeWidth: 1.33098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.355 99.3651L121.116 112.075C118.718 110.225 116.979 107.435 116.354 103.979C115.856 101.22 116.133 98.3953 117.027 95.7736C118.538 91.3445 121.808 87.4947 126.069 85.517L130.355 99.3651Z",
    fill: "#875FFE",
    stroke: "black",
    strokeWidth: 1.33098
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.64696,
    cy: 2.64696,
    r: 2.64696,
    transform: "matrix(0.949746 -0.31302 0.177795 0.984068 50.3008 92.4849)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.64696,
    cy: 2.64696,
    r: 2.64696,
    transform: "matrix(0.949746 -0.31302 0.177795 0.984068 57.6387 90.0664)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.64696,
    cy: 2.64696,
    r: 2.64696,
    transform: "matrix(0.949746 -0.31302 0.177795 0.984068 64.9766 87.6479)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.3733,
    height: 16.7073,
    rx: 1.48287,
    transform: "matrix(0.949746 -0.31302 0.177795 0.984068 61.9609 114.523)",
    fill: "#7E33E9",
    stroke: "black",
    strokeWidth: 1.33098
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.3733,
    height: 10.6003,
    rx: 1.48287,
    transform: "matrix(0.949746 -0.31302 0.177795 0.984068 78.6855 115.378)",
    fill: "#875FFE",
    stroke: "black",
    strokeWidth: 1.33098
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.3733,
    height: 23.8295,
    rx: 1.48287,
    transform: "matrix(0.949746 -0.31302 0.177795 0.984068 91.9746 97.2051)",
    fill: "#F56087",
    stroke: "black",
    strokeWidth: 1.33098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0664 135.691L109.565 120.036",
    stroke: "black",
    strokeWidth: 1.33098,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.3087,
    height: 15.5149,
    rx: 3.70717,
    transform: "matrix(0.949746 -0.31302 0.177795 0.984068 66.582 140.546)",
    fill: "#DFD4FF",
    stroke: "black",
    strokeWidth: 1.33098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.965 139.13L123.711 132.485L125.991 132.927L131.422 128.207L134.486 128.934L141.178 120.76L144.772 123.265L150.798 114.876",
    stroke: "#875FFE",
    strokeWidth: 1.33098,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.07616,
    cy: 3.07616,
    r: 3.07616,
    transform: "matrix(0.949746 -0.31302 0.177795 0.984068 72.6035 143.443)",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33098
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.66679,
    cy: 3.66679,
    r: 3.66679,
    transform: "matrix(0.949746 -0.31302 0.177795 0.984068 83.0586 139.381)",
    fill: "#875FFE",
    stroke: "black",
    strokeWidth: 1.33098
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.48231,
    cy: 4.48231,
    r: 4.48231,
    transform: "matrix(0.949746 -0.31302 0.177795 0.984068 94.5957 134.729)",
    fill: "#F56087",
    stroke: "black",
    strokeWidth: 1.33098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.205 123.862L119.964 139.13L155.229 127.506",
    stroke: "black",
    strokeWidth: 1.33098,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.20358,
    cy: 1.20358,
    r: 1.20358,
    transform: "matrix(0.949746 -0.31302 0.177795 0.984068 122.492 131.81)",
    fill: "#F56087"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.20358,
    cy: 1.20358,
    r: 1.20358,
    transform: "matrix(0.949746 -0.31302 0.177795 0.984068 133.094 127.757)",
    fill: "#F56087"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.20358,
    cy: 1.20358,
    r: 1.20358,
    transform: "matrix(0.949746 -0.31302 0.177795 0.984068 139.863 120.304)",
    fill: "#F56087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5631 77.3804C27.1092 60.6552 28.5733 49.5845 31.2795 42.5702C27.805 43.055 18.8186 43.0043 10.67 38.9235C10.9003 47.408 9.55039 67.5393 2.30867 80.1888C7.40565 83.8521 19.1343 89.8726 28.6077 87.501C30.5737 87.0089 32.265 85.7563 33.348 84.0434C34.2276 82.6523 35.1032 80.8626 35.492 78.9315C32.2926 78.1346 29.5011 77.6296 27.5631 77.3804Z",
    fill: "#B936D3",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2787 42.5704C28.5725 49.5846 27.1084 60.6554 27.5623 77.3805C29.5004 77.6297 32.2918 78.1347 35.4912 78.9316C35.1024 80.8628 34.2268 82.6525 33.3472 84.0436C32.2642 85.7565 30.5729 87.009 28.607 87.5012C22.6325 88.9968 15.7612 87.1548 10.222 84.6712C23.4831 77.9388 26.6813 53.9266 26.6228 42.762C28.5812 42.8203 30.1971 42.7213 31.2787 42.5704Z",
    fill: "#AA25C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5631 77.3804C27.1092 60.6552 28.5733 49.5845 31.2795 42.5702C27.805 43.055 18.8186 43.0043 10.67 38.9235C10.9003 47.408 9.55039 67.5393 2.30867 80.1888C7.40565 83.8521 19.1343 89.8726 28.6077 87.501C30.5737 87.0089 32.265 85.7563 33.348 84.0434C34.2276 82.6523 35.1032 80.8626 35.492 78.9315C32.2926 78.1346 29.5011 77.6296 27.5631 77.3804Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5624 77.3804C29.5004 77.6296 32.2919 78.1346 35.4913 78.9315C35.1025 80.8626 34.2269 82.6523 33.3473 84.0434C32.9558 84.6626 32.4848 85.2217 31.9501 85.7064C33.1771 81.3853 29.5362 78.3553 27.5624 77.3804Z",
    fill: "#6137DE",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5631 77.3803C25.8822 15.4441 50.5042 31.0495 67.1035 43.0519L57.153 88.3231C48.0228 81.4387 33.6222 78.1594 27.5631 77.3803Z",
    fill: "#B936D3",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1014 43.0518L57.1509 88.323C53.15 85.3062 48.1369 82.9816 43.2571 81.2564C59.7525 72.0078 60.6589 48.2888 59.0502 37.5854C61.8397 39.2986 64.5643 41.2173 67.1014 43.0518Z",
    fill: "#AA25C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5631 77.3803C25.8822 15.4441 50.5042 31.0495 67.1035 43.0519L57.153 88.3231C48.0228 81.4387 33.6222 78.1594 27.5631 77.3803Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5646 35.3289C67.4545 35.0905 66.3614 35.7972 66.123 36.9073L48.1458 120.627C47.9075 121.737 48.6141 122.83 49.7242 123.069C50.8344 123.307 51.9275 122.601 52.1659 121.49L70.1431 37.7705C70.3814 36.6604 69.6748 35.5672 68.5646 35.3289Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.724 98.4034C151.53 109.543 166.887 112.246 178.027 104.441C189.166 96.6356 191.869 81.2778 184.064 70.1382C176.259 58.9987 160.901 56.2956 149.762 64.1009C138.622 71.9061 135.919 87.2638 143.724 98.4034ZM147.923 95.4613C154.103 104.282 166.264 106.422 175.085 100.242C183.905 94.0614 186.046 81.9007 179.865 73.08C173.685 64.2594 161.524 62.1191 152.704 68.2995C143.883 74.4799 141.743 86.6406 147.923 95.4613Z",
    fill: "#8963FE",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.307,
    y: 100.215,
    width: 16.8948,
    height: 5.67763,
    transform: "rotate(54.982 177.307 100.215)",
    fill: "#BDB0FF",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.473,
    y: 108.218,
    width: 26.9779,
    height: 8.2272,
    rx: 4.03935,
    transform: "rotate(54.982 184.473 108.218)",
    fill: "#B936D3",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.084 111.602C179.13 112.977 179.079 114.857 180.096 116.308L190.855 131.664C192.159 133.525 194.724 133.976 196.585 132.673C197.911 131.743 198.522 130.172 198.29 128.673C198.021 129.061 197.68 129.409 197.27 129.696C195.409 131 192.844 130.548 191.541 128.688L180.781 113.331C180.407 112.797 180.177 112.205 180.084 111.602Z",
    fill: "#A924C3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.473,
    y: 108.218,
    width: 26.9779,
    height: 8.2272,
    rx: 4.03935,
    transform: "rotate(54.982 184.473 108.218)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.053,
    cy: 82.1091,
    r: 19.5015,
    transform: "rotate(54.982 166.053 82.1091)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.028 87.1591C168.173 87.5679 167.149 87.2063 166.74 86.3515C166.362 85.5611 166.162 84.8338 166.141 84.1695C166.132 83.4727 166.214 82.8265 166.388 82.2309C166.573 81.6028 166.806 81.0192 167.088 80.4799C167.359 79.9186 167.602 79.3841 167.818 78.8763C168.045 78.3361 168.18 77.7997 168.222 77.2671C168.286 76.724 168.192 76.189 167.94 75.6621C167.825 75.4206 167.66 75.1619 167.448 74.886C167.235 74.6102 166.95 74.382 166.594 74.2016C166.25 73.9887 165.827 73.8942 165.326 73.9181C164.814 73.92 164.218 74.0836 163.537 74.4091C162.791 74.766 162.24 75.1645 161.884 75.6045C161.55 76.034 161.346 76.4822 161.272 76.9489C161.21 77.3832 161.225 77.808 161.315 78.2232C161.634 79.3705 161.308 80.6141 160.233 81.1278L159.923 81.2763C158.677 81.8721 157.146 81.3607 156.63 80.0797C156.442 79.6124 156.296 79.1847 156.258 78.9016C156.174 78.1055 156.221 77.3281 156.397 76.5693C156.585 75.778 156.925 75.022 157.417 74.3014C157.898 73.5588 158.525 72.8678 159.298 72.2283C160.071 71.5888 160.996 71.0119 162.072 70.4975C162.994 70.0565 163.892 69.7349 164.766 69.5326C165.652 69.2978 166.486 69.2091 167.269 69.2664C168.063 69.2913 168.795 69.4402 169.465 69.7132C170.135 69.9862 170.743 70.3833 171.289 70.9045C171.835 71.4257 172.292 72.0705 172.659 72.8389C173.121 73.8048 173.372 74.6964 173.412 75.5134C173.442 76.3085 173.347 77.0688 173.127 77.7942C172.919 78.4872 172.652 79.141 172.325 79.7557C171.999 80.3703 171.694 80.9745 171.412 81.5682C171.141 82.1294 170.962 82.6869 170.876 83.2405C170.857 83.3645 170.87 83.5373 170.905 83.7376C171.122 84.9889 170.7 86.3592 169.555 86.9071L169.028 87.1591ZM172.734 93.6408C171.461 94.2496 169.935 93.7111 169.327 92.438C168.718 91.1649 169.256 89.6393 170.529 89.0305L170.595 88.999C171.868 88.3902 173.394 88.9287 174.003 90.2018C174.612 91.4749 174.073 93.0005 172.8 93.6093L172.734 93.6408Z",
    fill: "#F56087",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.884 96.2418C153.69 107.381 169.047 110.084 180.187 102.279C191.327 94.4739 194.03 79.1162 186.224 67.9766C178.419 56.837 163.061 54.134 151.922 61.9392C140.782 69.7445 138.079 85.1022 145.884 96.2418ZM150.083 93.2996C156.264 102.12 168.424 104.261 177.245 98.0802C186.066 91.8998 188.206 79.739 182.025 70.9184C175.845 62.0978 163.684 59.9574 154.864 66.1378C146.043 72.3182 143.903 84.479 150.083 93.2996Z",
    fill: "#BDB0FF",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.9774,
    cy: 61.7475,
    r: 2.11806,
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.997,
    cy: 127.805,
    r: 2.11806,
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.397,
    cy: 51.3368,
    r: 2.11806,
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.8613,
    cy: 50.7529,
    r: 3.86325,
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.977,
    cy: 43.4262,
    r: 3.86325,
    fill: "#611FE2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.4609,
    cy: 106.738,
    r: 3.86325,
    fill: "#611FE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_24415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white",
    transform: "translate(0 0.200195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudienceEmpty1);
export default __webpack_public_path__ + "static/media/audience-empty1.8840900bc53dc9fd2b09b3daeb710f2a.svg";
export { ForwardRef as ReactComponent };